<div class="pt-4 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-4 pl-md-4 mb-6" *ngIf="serverError === null">

  <div class="row">
    <div class="col">
      <p class="text-center w-100 mb-2"><b>
        Custom Inbox Items
        <span *ngIf="inboxResponse">
          ({{ inboxResponse.count.toLocaleString() }})
        </span>
      </b></p>
    </div>
  </div>

  <div class="alert customer-alert text-center" role="alert"
       [class.alert-success]="modalResult.status === CallbackResultStatus.success"
       *ngIf="modalResult !== null">
    {{ modalResult.text }}
  </div>

  <!-- One flex row: quick-filter selects on the left, buttons pushed right by
       ml-auto. When there isn't room, flex-wrap drops the button group onto
       its own line (source order keeps the selects first). -->
  <div class="d-flex flex-wrap align-items-start mb-1">
    <select class="custom-select w-auto mr-2 mb-2"
            [(ngModel)]="filters.is_resolved"
            (ngModelChange)="handleFilterChange()">
      <option [ngValue]="false">
        Status: Unresolved
      </option>
      <option [ngValue]="true">
        Status: Resolved
      </option>
    </select>
    <select class="custom-select w-auto mr-2 mb-2"
            [(ngModel)]="filters.inbox_id"
            (ngModelChange)="handleFilterChange()">
      <option [ngValue]="undefined">
        Inbox: All Custom
      </option>
      <option *ngIf="selectedInboxInactive()" [ngValue]="filters.inbox_id">
        Inbox: {{ selectedInboxDisplay() }}
      </option>
      <!-- While a deep-linked inbox_id is loading, the pinned option above is
           already showing "Loading..." — don't render a second one. -->
      <option *ngIf="loadingInboxList && !selectedInboxInactive()" disabled class="disabled">
        Loading...
      </option>
      <ng-container *ngIf="!loadingInboxList">
        <option *ngFor="let inbox of activeInboxes" [ngValue]="inbox.id">
          Inbox: {{ inbox.name }}
        </option>
        <option *ngIf="activeInboxes.length === 0" disabled class="disabled">
          No custom inboxes configured
        </option>
      </ng-container>
    </select>
    <div class="ml-auto">
      <button class="btn btn-outline-primary mr-2 mb-2" type="button"
              [disabled]="loadingInboxList"
              [class.disabled]="loadingInboxList"
              (click)="openEditFiltersModal()">
        Edit Filters
      </button>
      <div class="dropdown d-inline-block align-middle mb-2">
        <button class="btn btn-outline-primary dropdown-toggle"
                type="button" id="moreDropdownButton"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          More
        </button>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="moreDropdownButton">
          <a class="dropdown-item"
             [class.disabled]="loadingInbox"
             [class.cursor-pointer]="!loadingInbox"
             (click)="!loadingInbox && openExportListModal()">Export List</a>
          <a class="dropdown-item"
             [class.disabled]="loadingSavedView"
             [class.cursor-pointer]="!loadingSavedView"
             (click)="!loadingSavedView && openSelectReportColumnsModal()">Configure Columns</a>
          <a class="dropdown-item"
             [class.disabled]="loadingSavedView"
             [class.cursor-pointer]="!loadingSavedView"
             (click)="!loadingSavedView && openSavedViewsModal()">Saved Views</a>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="getActiveFilters().length > 0" class="clearfix mb-2">
    <span *ngFor="let activeFilter of getActiveFilters()"
          class="filter-item mb-2 mr-2 cursor-pointer"
          (click)="openEditFiltersModal()">{{ activeFilter }}</span>
  </div>

  <app-saved-report-view-toolbar
    [savedView]="savedView"
    [loadingSavedView]="loadingSavedView"
    [savedViewEdited]="savedViewEdited"
    [personalDefaultViewId]="defaultReportViewId"
    [organizationDefaultViewId]="organizationDefaultReportViewId"
    (renameView)="openRenameSavedViewModal()"
    (deleteView)="deleteSavedView()"
    (saveChanges)="updateSavedView()"
    (saveAsNew)="openCreateSavedViewModal()">
  </app-saved-report-view-toolbar>

  <div class="rounded-table-wrapper table-responsive">
    <table class="table table-hover">

      <thead>
      <tr>
        <th *ngFor="let col of columns; let first = first;"
            scope="col"
            class="text-nowrap"
            [class.sticky-column-left]="first">
          <span [ngbTooltip]="ExportColumns.COLUMN_HELP_TEXT[col]" container="body">
            {{ ReportColumns.COLUMN_HEADER_OVERRIDES[col] || col }}
          </span>
        </th>
        <th scope="col" class="text-nowrap sticky-column-right"></th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingInbox && resultsPresent()">
      <ng-template #customCell let-item="row" let-col="col">
        <ng-container [ngSwitch]="col">
          <ng-container *ngSwitchCase="ReportColumns.COLUMN_NAME_TIMESTAMP">
            <span class="text-nowrap">
              {{ timeStringFromISO8601(item.created_at, orgConfig.getOrganizationConfig().time_zone) }},
              {{ dateStringFromISO8601(item.created_at, orgConfig.getOrganizationConfig().time_zone) }}
            </span>
          </ng-container>
          <ng-container *ngSwitchCase="ReportColumns.COLUMN_NAME_CUSTOMER">
            <!-- Deliberately a plain anchor rather than app-customer-link:
                 this page opens profiles in a new tab (its pre-refactor
                 behavior) so staff checking a customer mid-queue keep their
                 place in the worklist. -->
            <a [routerLink]="['/customers', item.customer_id.toString()]"
               target="_blank">
              {{ item.customer_first_name }}
              {{ item.customer_last_name }}
            </a>
          </ng-container>
          <ng-container *ngSwitchCase="ReportColumns.COLUMN_NAME_STATUS">
            <span class="text-nowrap" [class.text-danger]="!item.is_resolved">
              {{ item.is_resolved ? 'Resolved' : 'Unresolved' }}
            </span>
          </ng-container>
          <ng-container *ngSwitchCase="ReportColumns.COLUMN_NAME_RESOLVED_AT">
            <span class="text-nowrap" *ngIf="item.resolved_at">
              {{ timeStringFromISO8601(item.resolved_at, orgConfig.getOrganizationConfig().time_zone) }},
              {{ dateStringFromISO8601(item.resolved_at, orgConfig.getOrganizationConfig().time_zone) }}
            </span>
            <span class="text-muted" *ngIf="!item.resolved_at">None</span>
          </ng-container>
          <ng-container *ngSwitchCase="ReportColumns.COLUMN_NAME_RESOLVED_BY">
            <span *ngIf="propExists(item.resolved_by_id)">
              {{ ExportColumns.getContentItem(item, ReportColumns.COLUMN_NAME_RESOLVED_BY) }}
            </span>
            <span class="text-muted" *ngIf="!propExists(item.resolved_by_id)">None</span>
          </ng-container>
        </ng-container>
      </ng-template>
      <tr *ngFor="let item of inboxResponse.results">
        <td *ngFor="let col of columns; let first = first;"
            [class.sticky-column-left]="first">
          <app-report-cell [column]="col"
                           [row]="item"
                           [getContentItem]="ExportColumns.getContentItem"
                           [customColumns]="ColumnsWithCustomHTML"
                           [objectIDColumns]="ObjectIDColumns"
                           [currencyColumns]="CurrencyColumns"
                           [dateColumns]="DateColumns"
                           [customTemplate]="customCell"></app-report-cell>
        </td>
        <td class="table-button-cell sticky-column-right">
          <button class="btn btn-outline-primary btn-sm float-right" style="min-width: 120px"
                  (click)="openModal(item);$event.preventDefault();">
            <ng-container *ngIf="!item.is_resolved">
              Review
            </ng-container>
            <ng-container *ngIf="item.is_resolved">
              View
            </ng-container>
          </button>
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="loadingInbox || !resultsPresent()">
      <tr>
        <td colspan="99">
          {{ loadingInbox ? 'Loading...' : 'No custom inbox items matching filters.' }}
        </td>
      </tr>
      </tbody>

    </table>
  </div>

  <div class="row">
    <div class="col-sm mb-2">
      <label for="resultsPerPage" class="pr-1 align-middle">
        Results per page:
      </label>
      <select id="resultsPerPage" class="form-control d-inline-block" style="width:80px;"
              [(ngModel)]="customInboxItemsPageSize"
              (change)="pageNumber = 1;loadReport();">
        <option [ngValue]="10">10</option>
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
    </div>
    <div class="col-sm">
      <nav aria-label="Pagination">
        <ul class="pagination justify-content-end">
          <li class="page-item" [class.disabled]="pageNumber <= 1">
            <button class="page-link" aria-label="Previous" [disabled]="pageNumber <= 1"
               (click)="setPage(pageNumber - 1)">
              <span aria-hidden="true">&laquo;</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 2">
            <button class="page-link" (click)="setPage(pageNumber - 2)">
              {{ pageNumber - 2 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 1">
            <button class="page-link" (click)="setPage(pageNumber - 1)">
              {{ pageNumber - 1 }}
            </button>
          </li>
          <li class="page-item active" aria-current="page">
            <button class="page-link" disabled>
              {{ pageNumber }}
              <span class="sr-only">(current)</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < lastPageNumber()">
            <button class="page-link" (click)="setPage(pageNumber + 1)">
              {{ pageNumber + 1 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < (lastPageNumber() - 1)">
            <button class="page-link" (click)="setPage(pageNumber + 2)">
              {{ pageNumber + 2 }}
            </button>
          </li>
          <li class="page-item" [class.disabled]="pageNumber >= lastPageNumber()">
            <button class="page-link" aria-label="Next" [disabled]="pageNumber >= lastPageNumber()"
               (click)="setPage(pageNumber + 1)">
              <span aria-hidden="true">&raquo;</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>

  <div class="floating-alert-container">
    <div class="alert alert-success alert-dismissible" role="alert" *ngIf="successMessage">
      {{ successMessage }}
      <button type="button" class="close" (click)="successMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
      <button type="button" class="close" (click)="errorMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>

</div>
